// extracted by mini-css-extract-plugin
export default {"truncate3lines":"FundSelectBox_truncate3lines__4FgVk"};